import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const Wrapper = styled.div`
  position: relative;
`

export const Trigger = styled.div<{ $isOpen?: boolean; $disabled?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 4px;
  gap: 8px;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  cursor: pointer;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

  background: ${({ $isOpen }) =>
    $isOpen ? COLORS.primaryLight : 'transparent'};

  &:hover {
    background: ${({ $disabled }) =>
      $disabled ? 'transparent' : COLORS.primaryLight};
  }
`

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const IconBox = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${COLORS.secondarySemiDark};
`

export const Num = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: ${COLORS.secondarySemiDark};
`

export const ArrowWrapper = styled.div<{ $isOpen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease-in-out;
  transform: rotate(${({ $isOpen }) => ($isOpen ? '180deg' : '0deg')});
  color: ${COLORS.secondarySemiDark};
`

export const Panel = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 6px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 4px;
  min-width: 230px;
  background: ${COLORS.white};
  border: 1px solid ${COLORS.borderColor};
  box-shadow: 0px 4px 10px rgba(56, 102, 255, 0.15);
  border-radius: 4px;
  z-index: 1000;
`

export const Item = styled.div<{ $selected?: boolean; $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  gap: 16px;
  width: 100%;
  height: 46px;
  border-radius: 4px;
  background: ${({ $selected }) => ($selected ? '#EEF5FF' : '#FFFFFF')};
  border: ${({ $selected }) =>
    $selected ? '1px solid #387DFF' : '1px solid transparent'};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

  &:hover {
    background: ${({ $disabled, $selected }) =>
      $disabled ? ($selected ? '#EEF5FF' : '#FFFFFF') : COLORS.primaryLight};
  }
`

export const ItemLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const ItemTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`

export const ItemHeader = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: ${COLORS.secondaryDark};
`

export const ItemSub = styled.span`
  display: flex;
  align-items: center;
  gap: 2px;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: ${COLORS.secondary};
`

export const CheckmarkWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`
